import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineFileIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M20 8.94a1.307 1.307 0 0 0-.06-.27v-.09a1.0702 1.0702 0 0 0-.19-.28l-6-6a1.071 1.071 0 0 0-.28-.19h-.09L13.06 2H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94Zm-6-3.53L16.59 8H14V5.41ZM18 19a1.0001 1.0001 0 0 1-1 1H7a1.0002 1.0002 0 0 1-1-1V5a1 1 0 0 1 1-1h5v5a1.0002 1.0002 0 0 0 1 1h5v9Z"/>
  </SvgIcon>
}

export default LineFileIcon
